import { render, staticRenderFns } from "./home_bargain.vue?vue&type=template&id=4f7c7f9c&scoped=true&"
import script from "./home_bargain.vue?vue&type=script&lang=js&"
export * from "./home_bargain.vue?vue&type=script&lang=js&"
import style0 from "./home_bargain.vue?vue&type=style&index=0&id=4f7c7f9c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7c7f9c",
  null
  
)

export default component.exports